import { css, cx } from '@emotion/css';

import {
  AlignItems,
  BorderRadius,
  Color,
  Display,
  FlexDirection,
  Font,
  FontWeight,
  JustifyContent,
  ScreenBreakpoint,
  Spacing,
} from '../../../../../../styles';

export const container = css`
  ${Spacing.px32}
  ${Spacing.py16}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.px16}
    ${Spacing.py8}
  }
`;

export const linkBankText = css`
  ${Spacing.mr12}
  p {
    ${Display.flex}
    ${AlignItems.center}
  }

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.mr0}
  }
`;

export const maxTranferValidationMessage = cx(
  'ant-form-item-explain-error',
  css`
    font-size: 14px;
    @media (max-width: ${ScreenBreakpoint.mobile.max}) {
      ${Font.sm}
      ${Spacing.mt4}
      ${Spacing.ml4}
    }
  `,
);

export const linkBankButton = css`
  ${Spacing.ml12}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.ml0}
    ${Spacing.mt12}

    .ant-btn {
      ${Spacing.px24}
    }
  }
`;

export const cardContainer = cx(
  css`
    background: ${Color.Red1};
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.35);
    ${BorderRadius.xxs}
  `,
);

export const linkBankContainer = css`
  ${Display.flex}
  ${FlexDirection.row}
  ${AlignItems.flexStart}
  ${JustifyContent.spaceBetween}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${FlexDirection.column}
    ${AlignItems.flexStart}
  }
`;

export const depositTitle = css`
  ${FontWeight.normal}
  ${Font.md}
  color: ${Color.Gray10};
`;

export const fieldTransactionLabel = css`
  ${FontWeight.semibold}
  ${Font.md}
  color: ${Color.Gray8};
  ${Display.flex}
`;

export const transactionSection = css`
  width: 100%;
  ${Display.flex}
  ${FlexDirection.row}
  ${JustifyContent.spaceBetween}
  ${AlignItems.center}
  
  @media (max-width: ${ScreenBreakpoint.mobile.min}) {
    ${FlexDirection.column}
    ${AlignItems.flexStart}
  }
`;
